import React, { useState } from 'react';
import { tabelStyles } from '../css/styles/componentStyles';
import "../css/classes/index.css";
import moment from 'moment';

const PAGE_SIZE = 6;

export default function ProductExpenseTable({ subTitle, year, data = [] }) {

  const [colPage, setColPage] = useState(0);

  const particulars = [
    { name: "Amount Infused", value: "amountInfused" },
    { name: "Loan Tenure (Month)", value: "loanTenureMonth" },
    { name: "Installment Received", value: "installmentReceived" },
    { name: "Total AUM", value: "totalAum" },
    { name: "AUM %", value: "aumPercentage" },
    { name: "NPA (1.5%)", value: "npa" },
    { name: "Net AUM (Disbursal)", value: "netAumDisbursal" },
    { name: "% Revenue", value: "revenuePercentage" },
    { name: "Total Revenue", value: "totalRevenue" },
    { name: "Processing Fee", value: "processingFee" },
    { name: "Interest fees", value: "interestFees" },
    { name: "Penalty and Late fee", value: "penaltyAndLateFee" }
  ];

  const getMonthWithYear = (yyyy_mm_dd) => {
    if (yyyy_mm_dd === null || yyyy_mm_dd === "") return "";
    return moment(yyyy_mm_dd, 'YYYY-MM-DD').format('MMM YYYY');
  };

  const totalCols = data.length;
  const totalPages = Math.ceil(totalCols / PAGE_SIZE);
  const safePage = Math.min(colPage, totalPages - 1);
  const visibleData = data.slice(safePage * PAGE_SIZE, safePage * PAGE_SIZE + PAGE_SIZE);

  const navBtnBase = {
    width: "28px", height: "28px", borderRadius: "8px",
    border: "1px solid rgba(226,232,240,0.8)",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: "16px", cursor: "pointer", transition: "all 0.2s ease",
    background: "#fff", color: "#1e293b",
  };
  const navBtnDisabled = { ...navBtnBase, background: "#f1f5f9", color: "#94a3b8", cursor: "not-allowed" };

  return (
    <div style={{ ...tabelStyles.container, margin: '24px' }}>
      <div style={{ borderRadius: "16px", border: "1px solid rgba(226, 232, 240, 0.8)", overflow: "hidden", backgroundColor: "#ffffff" }}>

        {/* ── Header: Product name (full width) ── */}
        <div style={{
          background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
          padding: '13px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <span style={{ color: 'white', fontWeight: '600', fontSize: '15px', letterSpacing: '0.4px', textAlign: 'center' }}>
            {subTitle}
          </span>
        </div>

        {/* ── Scrollable table area ── */}
        <div style={{
          ...tabelStyles.tableContainer,
          overflowX: "hidden",
          borderRadius: 0,
          border: "none",
          backgroundColor: "#ffffff",
        }}>
          <table style={{ ...tabelStyles.table, border: "none" }} className='commonBudgetTable'>

            <thead style={{ fontSize: "12px" }}>
              {/* Sticky month header row */}
              <tr style={{ position: "sticky", top: 0, zIndex: 4 }}>
                <th style={{
                  ...tabelStyles.expensesHeader,
                  position: 'sticky', left: 0, top: 0,
                  background: '#f8fafc', zIndex: 5,
                  borderBottom: '1px solid #e2e8f0', borderRight: '1px solid #e2e8f0',
                  padding: '10px 16px', fontSize: '12px', fontWeight: '700',
                  color: '#1e293b', textAlign: 'left', minWidth: '200px',
                }}>
                  Particulars
                </th>

                {visibleData.map((month, index) => (
                  <th
                    key={index}
                    style={{
                      ...tabelStyles.normalHeader,
                      background: '#f8fafc', color: '#475569',
                      fontWeight: '600', fontSize: '12px',
                      padding: '10px 12px', borderBottom: '1px solid #e2e8f0',
                      position: 'sticky', top: 0,
                    }}
                  >
                    {getMonthWithYear(month?.currentMonth ?? "")}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody style={{ fontSize: "12px" }}>
              {particulars.map((item, index) => (
                <tr key={index}>
                  <td style={{
                    ...tabelStyles.categoryCell,
                    position: 'sticky', left: 0,
                    background: 'white', zIndex: 1,
                  }}>
                    <div style={tabelStyles.categoryCellContent}>
                      <div style={{ textAlign: 'left', marginRight: "1rem" }}>{item.name}</div>
                      <span>▶</span>
                    </div>
                  </td>

                  {visibleData.map((value, vIndex) => (
                    <td key={vIndex} style={{ ...tabelStyles.valueCell, textAlign: 'center' }}>
                      {value[item.value]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>

          </table>
        </div>

        {/* ── Bottom pagination bar ── */}
        {totalPages > 1 && (
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: '12px', padding: '12px 20px',
            borderTop: '1px solid rgba(226, 232, 240, 0.8)',
            background: '#f8fafc',
          }}>
            <button
              onClick={() => setColPage(p => Math.max(0, p - 1))}
              disabled={safePage === 0}
              style={safePage === 0 ? { ...navBtnDisabled, width: '32px', height: '32px' } : { ...navBtnBase, width: '32px', height: '32px' }}
            >‹</button>

            <div style={{ display: 'flex', gap: '6px' }}>
              {Array.from({ length: totalPages }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setColPage(i)}
                  style={{
                    width: '32px', height: '32px', borderRadius: '8px',
                    border: i === safePage ? '1.5px solid #2c3e50' : '1px solid rgba(226,232,240,0.8)',
                    background: i === safePage ? 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)' : '#fff',
                    color: i === safePage ? '#fff' : '#64748b',
                    fontWeight: i === safePage ? '700' : '500',
                    fontSize: '13px', cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                >{i + 1}</button>
              ))}
            </div>

            <button
              onClick={() => setColPage(p => Math.min(totalPages - 1, p + 1))}
              disabled={safePage === totalPages - 1}
              style={safePage === totalPages - 1 ? { ...navBtnDisabled, width: '32px', height: '32px' } : { ...navBtnBase, width: '32px', height: '32px' }}
            >›</button>
          </div>
        )}

      </div>
    </div>
  );
}